/* eslint-disable max-len */

export enum ToolEnum {
  BASH = "bash",
  C = "c",
  CPP = "cpp",
  CSS = "css",
  DOCKER = "docker",
  ELECTRON = "electron",
  EXPRESS = "express",
  FIREBASE = "firebase",
  GIT = "git",
  GO = "go",
  HTML = "html",
  JAVA = "java",
  JAVASCRIPT = "javascript",
  NEST = "nest",
  NEXT = "next",
  NODE = "node",
  POSTGRES = "postgres",
  PYTHON = "python",
  RAILS = "rails",
  REACT = "react",
  REDIS = "redis",
  RUBY = "ruby",
  TYPESCRIPT = "typescript",
  WEBPACK = "webpack",
}

export const FLUENT_TOOLS = [
  ToolEnum.TYPESCRIPT,
  ToolEnum.JAVASCRIPT,
  ToolEnum.PYTHON,
  ToolEnum.JAVA,
  ToolEnum.REACT,
  ToolEnum.NODE,
  ToolEnum.NEST,
  ToolEnum.EXPRESS,
  ToolEnum.ELECTRON,
  ToolEnum.HTML,
  ToolEnum.CSS,
  ToolEnum.GIT,
];

export const USED_TOOLS = [
  ToolEnum.C,
  ToolEnum.CPP,
  ToolEnum.POSTGRES,
  ToolEnum.REDIS,
  ToolEnum.NEXT,
  ToolEnum.WEBPACK,
  ToolEnum.DOCKER,
  ToolEnum.BASH,
  ToolEnum.GO,
  ToolEnum.RAILS,
  ToolEnum.RUBY,
  ToolEnum.FIREBASE,
];

interface IconDetails {
  name: string;
  icon: string;
}

// Icon links.
export const LOGO_ICONS: Record<ToolEnum, IconDetails> = {
  [ToolEnum.BASH]: {
    name: "Bash",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg",
  },
  [ToolEnum.C]: {
    name: "C",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg",
  },
  [ToolEnum.CPP]: {
    name: "C++",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
  },
  [ToolEnum.CSS]: {
    name: "CSS",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
  },
  [ToolEnum.DOCKER]: {
    name: "Docker",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg",
  },
  [ToolEnum.ELECTRON]: {
    name: "Electron",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/electron/electron-original.svg",
  },
  [ToolEnum.EXPRESS]: {
    name: "Express",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original.svg",
  },
  [ToolEnum.FIREBASE]: {
    name: "Firebase",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
  },
  [ToolEnum.GIT]: {
    name: "Git",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
  },
  [ToolEnum.GO]: {
    name: "Go",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/go/go-original.svg",
  },
  [ToolEnum.HTML]: {
    name: "HTML",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
  },
  [ToolEnum.JAVA]: {
    name: "Java",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
  },
  [ToolEnum.JAVASCRIPT]: {
    name: "JavaScript",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  [ToolEnum.NEST]: {
    name: "NestJS",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nestjs/nestjs-original-wordmark.svg",
  },
  [ToolEnum.NEXT]: {
    name: "NextJS",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg",
  },
  [ToolEnum.NODE]: {
    name: "NodeJS",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg",
  },
  [ToolEnum.POSTGRES]: {
    name: "PostgreSQL",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg",
  },
  [ToolEnum.PYTHON]: {
    name: "Python",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
  },
  [ToolEnum.RAILS]: {
    name: "Rails",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/rails/rails-original-wordmark.svg",
  },
  [ToolEnum.REACT]: {
    name: "React",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  },
  [ToolEnum.REDIS]: {
    name: "Redis",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original-wordmark.svg",
  },
  [ToolEnum.RUBY]: {
    name: "Ruby",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ruby/ruby-original.svg",
  },
  [ToolEnum.TYPESCRIPT]: {
    name: "TypeScript",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
  },
  [ToolEnum.WEBPACK]: {
    name: "Webpack",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/webpack/webpack-original.svg",
  },
};
